<template>
  <div app>
    <app-header />

    <v-content>
      <v-app container>
        <router-view container-content></router-view>
      </v-app>
    </v-content>

    <app-footer />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    appHeader: () => import("./components/Header"),
    appFooter: () => import("./components/Footer")
  },
  data: () => ({
    //
  })
};
</script>

<style>
[container] {
  padding: 10px;
}

[container-content]::before {
  content: "";
  background: url(https://i.pinimg.com/originals/30/d3/2c/30d32c635890ab1b6c3cc40ee620097a.jpg) !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  opacity: 0.15;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

[container-content] {
  opacity: 0.75;
}

/* reset */

[app] {
  font-family: "Lato", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  font: inherit;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
a {
  text-decoration: none;
  color: black;
}

img,
a {
  cursor: pointer;
}
h3 {
  font-size: 1.5em;
  font-weight: bold;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>

